/**
 * TwoColumnLayout — DS Layout
 * Deux colonnes : main + aside (sidebar droite ou gauche)
 */

import styles from './TwoColumnLayout.module.css';

interface TwoColumnLayoutProps {
  main: React.ReactNode;
  aside: React.ReactNode;
  asidePosition?: 'left' | 'right';
  asideWidth?: string;
  className?: string;
}

export function TwoColumnLayout({
  main,
  aside,
  asidePosition = 'right',
  asideWidth = '320px',
  className = '',
}: TwoColumnLayoutProps) {
  return (
    <div
      className={`${styles.root} ${className}`}
      style={
        asidePosition === 'right'
          ? { gridTemplateColumns: `1fr ${asideWidth}` }
          : { gridTemplateColumns: `${asideWidth} 1fr` }
      }
    >
      {asidePosition === 'left' && <aside className={styles.aside}>{aside}</aside>}
      <main className={styles.main}>{main}</main>
      {asidePosition === 'right' && <aside className={styles.aside}>{aside}</aside>}
    </div>
  );
}
